import React from 'react';
import ReactDOM from 'react-dom';
import '../commoncss/reset.css';
import './reset.css';
import Layout from './layout';

/* eslint-disable */
const re = /24HOURLET,FOCUS24HOURLET|24HOURLET/;

const searchPathTemp = re.exec(window.location.pathname);

let searchPath = '';

if (searchPathTemp) {
    searchPath = searchPathTemp.shift();
}

allData.channelId = searchPath;
ReactDOM.render(<Layout content={allData} />, document.getElementById('root'));
/* eslint-enable */
